// Generated by `cargo run -p echo-wire --features ts --bin gen-dto-ts`.
// DO NOT EDIT: this file is the committed TypeScript twin of
// `wire/src/dto.rs` (web-plan.md D45); CI regenerates it and fails on
// drift. 64-bit integers are emitted as `number` — they travel as
// JSON numbers and stay far under 2^53 — and every open enum is
// widened with `UnknownString`, because a server newer than this
// build may say a word it has never heard (chat-api.md §7).

/** A value a newer server may send that this build cannot name. */
export type UnknownString = string & {};

export type EntityKind = { "type": "bold" } | { "type": "italic" } | { "type": "underline" } | { "type": "strike" } | { "type": "spoiler" } | { "type": "code" } | { "type": "pre", language?: string | null, } | { "type": "blockquote", expandable?: boolean, } | { "type": "text_link", url: string, } | { "type": "url" } | { "type": "mention", user_id: number, };

export type Entity = {
/**
 * Start, in UTF-16 code units.
 */
offset: number,
/**
 * Length, in UTF-16 code units; always > 0 after [`normalize`].
 */
length: number, } & ({ "type": "bold" } | { "type": "italic" } | { "type": "underline" } | { "type": "strike" } | { "type": "spoiler" } | { "type": "code" } | { "type": "pre", language?: string | null, } | { "type": "blockquote", expandable?: boolean, } | { "type": "text_link", url: string, } | { "type": "url" } | { "type": "mention", user_id: number, });

export type FileKind = "photo" | "video" | "voice" | "video_message" | "file" | UnknownString;

export type Attachment = {
/**
 * sha256 hex of the bytes — also the storage key and the cache key (D17).
 */
file_id: string, kind: FileKind, mime: string,
/**
 * `av1` | `h264` for video/video_message: lets the receiver decide whether
 * it can play the file *before* pulling 15 MiB (R18).
 */
codec?: string | null, size: number,
/**
 * Mandatory for photo/video/video_message and known before the bytes
 * arrive — without it the feed jumps while images load (§6.3).
 */
width?: number | null, height?: number | null, duration_ms?: number | null,
/**
 * The light weight of the picture, itself a blob (D233): a photo's
 * 128 px thumbnail, drawn while `file_id` — the preview — is still
 * arriving; a video's poster, which carries the preview weight
 * because there is no larger still behind it.
 */
thumb_file_id?: string | null,
/**
 * Voice notes: 100 buckets of 5 bits, packed then base64 (standard
 * alphabet, padded — the gateway's validator accepts `+/=`).
 */
waveform?: string | null, file_name?: string | null, spoiler?: boolean, };

export type AttachmentInput = { file_id: string, thumb_file_id?: string | null, waveform?: string | null, file_name?: string | null, codec?: string | null, spoiler?: boolean, };

export type Service = { "kind": "call" } & CallLog | { "kind": "joined" } | { "kind": "left" } | { "kind": "removed", user_id: number, } | { "kind": "admin_granted", user_id: number, } | { "kind": "admin_revoked", user_id: number, } | { "kind": "renamed", name: string, } | { "kind": "banned", user_id: number, until_ms?: number | null, } | { "kind": "unbanned", user_id: number, } | { "kind": "voice_muted", user_id: number, until_ms?: number | null, } | { "kind": "voice_unmuted", user_id: number, } | { "kind": "owner_changed", user_id: number, };

export type CallLog = {
/**
 * Everyone who was in the call at any point, in the order they arrived.
 * Deliberately not the live roster: the widget outlives the call and has
 * to answer "who was on it", and somebody who hung up early was still on
 * it. This is what the client's "participants" menu shows.
 */
participants: Array<number>,
/**
 * True while the call is running. A widget left `live` by a gateway that
 * restarted mid-call is cleared on the next startup
 * (`MessageStore::end_dangling_calls`), because nothing else ever could:
 * live rooms do not survive the process.
 */
live?: boolean,
/**
 * Wall-clock length, written when the call ends. Absent while it runs,
 * and absent for ever on one a restart interrupted — the gateway knows
 * the call is over but not when it stopped, and inventing a number would
 * put a wrong duration in the history permanently.
 */
duration_s?: number | null, end_reason?: CallEndReason | null, };

export type CallEndReason = "empty" | "alone_timeout" | "channel_deleted" | UnknownString;

export type Call = { channel_id: number,
/**
 * Who started it — the participant that walked into the empty room.
 */
started_by: number,
/**
 * Unix millis, so a client that connects mid-call can show a duration.
 */
started_at_ms: number,
/**
 * Everyone currently in the call, ascending. Also the roster the sidebar
 * draws for channels the reader is *not* in — the voice socket only ever
 * tells participants who else is there.
 */
participants: Array<number>, };

export type Message = { channel_id: number,
/**
 * Monotonic inside the channel; the pagination cursor (D16).
 */
seq: number, sender_id: number, sent_at_ms: number, edited_at_ms?: number | null,
/**
 * Client-side UUID: idempotent send and echo de-duplication.
 */
nonce: string, reply_to_seq?: number | null,
/**
 * The message `reply_to_seq` answers, as it stands when this one is
 * served (D273): the gateway reads it for every reply it hands out — a
 * page, the answer to a send or an edit, a socket frame — so a client
 * draws the header over a reply without holding what it answers. Absent
 * exactly when `reply_to_seq` is, and on everything an older gateway
 * sends. Read leniently: a quote this build cannot read is
 * [`ReplyTo::Unknown`] and costs the reply nothing (chat-api.md §7).
 */
reply_to?: ReplyTo | null,
/**
 * Also the caption when attachments are present.
 */
text: string,
/**
 * Lenient by construction: [`crate::text::EntityKind`] carries
 * `#[serde(other)] Unknown`, so a `type` this build cannot name parses to
 * a value rather than an error. A reader that must not silently accept
 * one — a server-to-server import, a replication path — says so itself
 * with [`crate::text::reject_unknown`]; the gateway's storage layer
 * already does (chat-api.md §7).
 */
entities?: Array<Entity>, attachments?: Array<Attachment>,
/**
 * The sender closed the card this message's link would get
 * (link-previews.md D289), so no reader's client draws one. The card
 * itself never travels (D278); this is the one fact about it that does,
 * because only the sender can say they did not want it. Absent on
 * everything an older client sent and everything an older gateway
 * serves — both mean «draw it», which is what they always did.
 */
no_link_preview?: boolean,
/**
 * The lifetime its sender gave it, in seconds (disappearing-messages.md
 * D296, D302). Present from the moment it is sent, whether or not the
 * clock has started; absent on a message that stays, which is every
 * message an older client sent, everything an older gateway serves, and
 * everything the server wrote itself.
 */
ttl_s?: number | null,
/**
 * When this message goes — Unix milliseconds on the **gateway's** clock,
 * which is the one that deletes it (D297).
 *
 * Absent until the clock starts, and the clock starts when somebody other
 * than the author has read it (D302): a lifetime is time to read a
 * message in, and a message nobody has opened has not begun to be read.
 * So a message with `ttl_s` and no deadline is waiting for its first
 * reader; one with both is counting; one with neither stays. An edit never
 * sets or moves it.
 */
expires_at_ms?: number | null,
/**
 * Present on the messages the *server* wrote (D71): the call widget and
 * the membership notices. Absent on everything a person typed, so a
 * client that has never heard of them renders the ordinary empty bubble
 * instead of breaking.
 */
service?: Service | null, };

export type ReplyTo = { "state": "live" } & ReplyQuote | { "state": "deleted" };

export type ReplyQuote = {
/**
 * Who wrote it — a name the client resolves like any other `sender_id`.
 */
sender_id: number,
/**
 * The start of its text: at most [`QUOTE_UNITS`] UTF-16 units, never
 * cut through a surrogate pair, and all of it when it is shorter.
 */
text?: string,
/**
 * Its attachments, whole — what the quote of an album counts and the
 * quote of a file names.
 */
attachments?: Array<Attachment>,
/**
 * Present when the server wrote it (§1.4): the quote then says what
 * kind of notice it was, in the reader's language.
 */
service?: Service | null, };

export type ReactionGroup = {
/**
 * Always the canonical form [`crate::emoji::canonical`] returned — the
 * store never holds anything else (D152).
 */
emoji: string,
/**
 * Exact, however many the list below shows: `count == users.len()` is the
 * client's own signal that the list is complete.
 */
count: number,
/**
 * At most [`MAX_REACTORS_LISTED`] reactor ids, oldest first — what the
 * chip's avatar row draws. A capped prefix, so the caller may be the
 * twentieth reactor and still absent from it (which is why `my_reactions`
 * exists).
 */
users: Array<number>, };

export type SeqReactions = { seq: number,
/**
 * Always the canonical form [`crate::emoji::canonical`] returned — the
 * store never holds anything else (D152).
 */
emoji: string,
/**
 * Exact, however many the list below shows: `count == users.len()` is the
 * client's own signal that the list is complete.
 */
count: number,
/**
 * At most [`MAX_REACTORS_LISTED`] reactor ids, oldest first — what the
 * chip's avatar row draws. A capped prefix, so the caller may be the
 * twentieth reactor and still absent from it (which is why `my_reactions`
 * exists).
 */
users: Array<number>, };

export type MyReaction = { seq: number, emoji: string, };

export type ReactionsAnswer = { reactions: Array<ReactionGroup>,
/**
 * Absent means cleared — the same omit-the-null convention as §1.
 */
my_reaction?: string | null, };

export type FriendEntry = { user_id: number, channel_id: number, };

export type IncomingRequest = { user_id: number, requested_at_ms: number, };

export type FriendsSnapshot = { friends: Array<FriendEntry>,
/**
 * Visible only. A hidden row is not "an old request" to its recipient —
 * it is nothing at all, and that is the whole of D171.
 */
incoming: Array<IncomingRequest>,
/**
 * Every request this account sent that has not been answered or cancelled,
 * **hidden rows included and indistinguishable** (D171/D172): the sender
 * can never tell a decline, a block or plain silence apart.
 */
outgoing: Array<number>, blocked: Array<number>,
/**
 * `crate::account::FRIEND_POLICIES`; an **open** string rather than an
 * enum so the set can grow without a migration (D173) — a value this
 * build has never heard of is rendered as itself.
 */
policy: string, };

export type Relation = "none" | "outgoing" | "incoming" | "friends" | "self" | UnknownString;

export type Friendship = { relation: Relation,
/**
 * Whether a request would be accepted — computed from the *target's*
 * policy and deliberately ignoring blocks (D172/D176), so that a blocked
 * caller reads exactly what anybody else reads.
 */
can_request: boolean,
/**
 * When this person was last visibly around, for a **friend** who is not
 * visible right now (D193). Omitted — never `null` — in every other case,
 * because there is nothing for a client to tell apart: not a friend,
 * visible right now, never seen, and a gateway that predates the column
 * all draw the same nothing.
 */
last_seen_ms?: number | null, };

export type MembershipChange = "joined" | "left" | "role" | UnknownString;

export type ChannelSettings = {
/**
 * D114. Invisible to non-members; history and media closed.
 *
 * The whole of the access state since D295: `has_password` stood beside
 * it until channels stopped having passwords, and the key is gone from
 * the wire rather than pinned to `false` — every client that ever read it
 * read it through a `serde` default, so its absence is the `false` it
 * always meant.
 */
is_private: boolean, max_voice_ms: number, max_media_bytes: number, max_message_chars: number,
/**
 * Seconds between one person's messages; `0` is off.
 */
slowmode_s: number,
/**
 * Voice for the whole channel (D126). `true` from a gateway that has never
 * heard of the switch, which is what it did.
 */
voice_enabled: boolean,
/**
 * The admin's one switch against a rainbow (D137): everybody's bubbles
 * take the channel's scheme, personal colours included.
 */
channel_scheme_only: boolean,
/**
 * The bubble accent as a hex pair (D136).
 */
accent_light?: string | null, accent_dark?: string | null,
/**
 * The background slots (D134/D168): either half may stand alone, and the
 * theme with no picture of its own wears the other's — see
 * [`ChannelSettings::background`].
 */
bg_light_file_id?: string | null, bg_dark_file_id?: string | null,
/**
 * 0..=100 each, applied as a CSS filter to the background element and
 * never to the feed above it (D135).
 */
bg_blur: number, bg_brightness: number, };

export type ChannelState = { channel_id: number,
/**
 * Who owns the channel (D109). On every row rather than only on the one
 * the reader has open: the sidebar is where "my channels" is decided, and
 * an owner has to know which of them they can never simply leave. `0`
 * from a gateway that predates owners.
 */
owner_id: number,
/**
 * What kind of channel this is (D168): `standard`, `dm` for a direct
 * conversation, or `group` for one that is private from birth and for
 * good (D274). Omitted when it is the ordinary kind, exactly as `call`
 * and `description` are — absent has to stay cheap, and absent reads as
 * `standard` both for a client that has never heard of the field and for
 * one that has.
 */
kind?: string,
/**
 * The **other** member of a DM (D169), so a client can draw their face
 * rather than the channel's initials. Absent on every other kind.
 */
peer_id?: number | null,
/**
 * For a DM this is built per viewer and holds the *peer's* resolved name
 * (D169) — `channels.name` is stored empty, because a DM has no one name.
 */
name: string,
/**
 * What the channel is for (D74) — the channel profile's "about". Rides
 * along with the row rather than waiting for a screen to ask for it: it is
 * one short string per channel, and the alternative is a round trip every
 * time somebody opens the profile of a channel they are already reading.
 */
description?: string | null,
/**
 * The channel's photo (D74), as the same `file_id` an avatar is.
 */
avatar_file_id?: string | null,
/**
 * Unix seconds of the channel's creation (D73) — what the client hashes
 * with the name for the circle beside the row. Not a display date:
 * nothing in the sidebar prints it.
 */
created_at: number, max_seq: number, last_read_seq: number, unread: number,
/**
 * Whether the reader is a member of this channel (D72). This is not about
 * seeing it — it is what decides whether the composer or the "join"
 * button is drawn.
 */
member: boolean,
/**
 * Whether the reader administers *this channel* — a different thing from
 * `users.is_admin`, which administers the server and outranks it.
 */
admin: boolean,
/**
 * How many people are in the channel.
 */
members: number,
/**
 * The door, for **everybody who can see the row** — not only for
 * members, unlike the settings object below (D141). This is not a hole in
 * D114: a private channel is still absent from this list for anybody who
 * is not in it, so `is_private` is only ever `true` on a row whose reader
 * is already inside.
 */
is_private: boolean,
/**
 * Newest non-deleted message, for the sidebar preview.
 */
last_message?: Message | null,
/**
 * The chips on `last_message`. Reactions never ride on a [`Message`]
 * (reactions-plan.md D147), so the row carries them beside it — and they
 * are the *real* ones, because a hardcoded empty list would read as
 * "nobody reacted", which is a silent lie. No `my_reactions` here: the
 * sidebar draws no chips.
 */
reactions?: Array<ReactionGroup>,
/**
 * The call in progress, if any. Absent is the ordinary case. This is how
 * a client that starts up (or reconnects) mid-call learns about one:
 * `call_started` is an event, and the socket replays nothing.
 */
call?: Call | null,
/**
 * The channel's settings, whole, and only for members (D141). Laziness is
 * a storage detail and must not leak into JSON: a missing *key* would make
 * every client re-implement the defaults, and they would drift. A
 * non-member reads a public channel in the ordinary appearance.
 */
settings?: ChannelSettings | null, };

export type ChannelSummary = { channel_id: number,
/**
 * Who owns it (D109). On the profile rather than only in the settings
 * object, because the channel card is where a reader finds out whose room
 * this is, and it is drawn for everybody — the settings screen is not.
 */
owner_id: number, name: string, description: string | null, avatar_file_id: string | null,
/**
 * The door (D114), public like the rest of the profile. `false` from a
 * gateway that predates it — which is what its channels were.
 */
is_private: boolean, };

export type ChannelMember = { user_id: number,
/**
 * Administers this channel.
 */
admin: boolean, joined_at_ms: number, };

export type MembersResponse = { members: Array<ChannelMember>, };

export type ChannelBan = { user_id: number, banned_by: number,
/**
 * Absent means for ever, on the way in exactly as on the way out.
 */
until_ms?: number | null, banned_at_ms: number, };

export type BansResponse = { bans: Array<ChannelBan>, };

export type Invite = { token: string, expires_at_ms: number, };

export type Joined = { admin: boolean, };

export type LinkPreview = {
/**
 * `og:site_name`, or the host the page answered from (without a leading
 * `www.`) when it names none — the line a card opens with.
 */
site_name?: string, title?: string, description?: string,
/**
 * The page's picture, fetched and checked by the gateway, if it had one
 * worth drawing.
 */
image?: LinkImage | null, };

export type LinkImage = {
/**
 * sha256 of the bytes, lowercase hex — the same shape a `file_id` has, and
 * for the same reason: the address *is* the content, so it never goes
 * stale and a client may keep it for as long as it likes.
 */
id: string, width: number, height: number, };

export type ChannelCard = { channel_id: number,
/**
 * `standard`, `dm` or `group` (D168, D274); omitted for the ordinary
 * kind, as on [`ChannelState`].
 */
kind?: string,
/**
 * For a direct conversation, the *other* member's name (D169) — built per
 * viewer, like the sidebar row.
 */
name: string, description?: string | null, avatar_file_id?: string | null,
/**
 * How many people are in it.
 */
members: number,
/**
 * Whether the reader is one of them — the card's button hangs on this.
 */
member: boolean, is_private: boolean, };

export type UserStatus = "online" | "afk" | "dnd" | "offline" | "invisible" | "in_call" | UnknownString;

export type PublicStatus = "online" | "afk" | "dnd" | "offline" | "in_call" | UnknownString;

export type ManualStatus = "dnd" | "invisible" | UnknownString;

export type PresenceEntry = { user_id: number,
/**
 * A widened [`PublicStatus`] for everybody, and the true self view —
 * `invisible` included — for the caller's own row.
 */
status: UserStatus, };

export type UserJson = { user_id: number, username: string,
is_admin: boolean,
/**
 * Deliberately no `skip_serializing_if` on the three below (D67): a
 * removed avatar and an absent key must read differently on the wire, or
 * a client cannot tell "cleared" from "nothing changed".
 */
display_name: string | null, bio: string | null, avatar_file_id: string | null,
/**
 * Unix seconds of the registration (D73). The client seeds the initials
 * circle with the name *and* this, so two people who happen to share a
 * display name still get different colours.
 */
created_at: number,
/**
 * The personal bubble pair (D137), drawn on *other people's* screens —
 * that is the whole reason it is server-side and the personal background
 * is not (D139).
 */
bubble_light: string | null, bubble_dark: string | null,
/**
 * The standing status choice (D182), `null` for auto — and no
 * `skip_serializing_if`, for the reason the three above have none. What
 * the picker opens marked.
 */
manual_status: ManualStatus | null,
/**
 * D311: this account has to prove an e-mail address before anything but
 * `GET /v1/me` and `/v1/me/email/start|confirm` opens to it — the
 * gateway answers every other authenticated route and both sockets with
 * 403 until it does. Set by `GET /v1/me` alone, since every other route
 * answering this shape is one such an account cannot reach; `false`
 * from a gateway that does not confirm addresses, and absent (so
 * `false`) from one older than the rule.
 */
must_confirm_email: boolean, };

export type DirectoryEntry = { user_id: number, username: string, display_name: string | null,
/**
 * What this person wrote about themselves — the About section of their
 * profile screen (friends-plan.md §6.3).
 */
bio: string | null, avatar_file_id: string | null,
/**
 * Unix seconds of the registration (D73), the second half of the avatar
 * colour seed.
 */
created_at: number,
/**
 * The personal bubble colour (D137), a light/dark pair. It lives here —
 * and not only on `/v1/me` — because the whole point of the colour is
 * that *other* people's clients paint your messages with it, and the
 * directory is the only thing they hold about you.
 */
bubble_light: string | null, bubble_dark: string | null, };

export type StateResponse = { channels: Array<ChannelState>,
/**
 * The friend-state twin of the `t: "friends"` event (D174) — the same
 * object, so a startup and a live change go through one writer. Absent
 * from a gateway that predates friends, which reads as "no friends, no
 * requests, everyone may ask" — exactly the world such a stand has.
 */
friends: FriendsSnapshot,
/**
 * Everyone who is not offline, plus the caller's own true row (D182).
 *
 * **This is the capability probe.** A gateway that has presence always
 * sends the key, empty list included; `None` means the server has never
 * heard of it, and the client answers by drawing no dots, offering no
 * picker, and — above all — never sending an `activity` frame it would
 * have no way of knowing was ignored.
 */
presence?: Array<PresenceEntry> | null,
/**
 * What the gateway's clock read when it wrote this answer, Unix
 * milliseconds (disappearing-messages.md D298). A message's
 * `expires_at_ms` is on that clock, and a client has to read it through
 * the difference from its own; a live frame teaches it the difference,
 * but a client that has just started has not heard one yet — and the
 * first thing it does is take in a page of history, where a machine
 * running a minute fast would drop every message with less than a
 * minute left. This is the sample that comes before the first page.
 * Absent from a gateway older than the field, which leaves such a client
 * where it was: assuming the clocks agree until a frame says otherwise.
 */
server_time_ms?: number | null, };

export type PageResponse = { messages: Array<Message>,
/**
 * Sibling keys, not fields of a message (D147): reactions never ride on a
 * [`Message`], because `MessageEdited` replaces a message whole and a
 * `reactions` field there would be wiped by every edit echo. Both keys
 * are omitted when empty — and absent from a gateway that predates them,
 * which reads identically.
 */
reactions?: Array<SeqReactions>,
/**
 * Where the *caller* stands (D149) — per-request, never broadcast.
 */
my_reactions?: Array<MyReaction>, };

export type MediaResponse = {
/**
 * Photographs and films in the channel's live messages, counted as
 * attachments: an album of four is four.
 */
total: number,
/**
 * How many of them come before this page — the position, from the oldest,
 * of the page's first item, which is what «3» in «3 of 37» is counted
 * from.
 */
before: number,
/**
 * Ascending by `seq`, each with all of its attachments; the reader keeps
 * the visual ones.
 */
messages: Array<Message>, };

/** One message's clock, started (D302): which message, and when it goes. */
export type Expiring = { seq: number,
/** Unix milliseconds on the gateway's clock, as `Message.expires_at_ms`. */
expires_at_ms: number, };

export type ServerEvent = { "t": "ready", user_id: number, } | { "t": "message" } & Message | { "t": "message_edited" } & Message | { "t": "message_deleted", channel_id: number, seq: number, } |
/**
 * Somebody other than the author has read a message that carries a
 * lifetime, so its clock has started (disappearing-messages.md D302).
 *
 * Its own event, and the only one this feature adds: the deletion itself
 * is still the ordinary `message_deleted` (D297). A list, because one read
 * mark can start the clock on everything that arrived while the reader was
 * away; each entry carries its own deadline, since the messages were given
 * different lifetimes by their senders.
 */
{ "t": "message_expiring", channel_id: number, messages: Array<Expiring>, } | { "t": "reaction", channel_id: number, seq: number,
/**
 * Who acted. Also how a client knows a chip is its own on this path
 * (D149): the event names the actor, and the client compares it with
 * itself — nothing per-viewer ever rides a broadcast.
 */
user_id: number,
/**
 * The message's author, on the frame rather than looked up locally
 * (D159): the recipient may not have that message loaded, or that
 * channel open — and the message that scrolled away hours ago is
 * exactly the one a toast matters for.
 */
author_id: number,
/**
 * What `user_id` now has set; `null` means the reaction was cleared.
 * Deliberately no `skip_serializing_if`: an absent key and a cleared
 * reaction must not read the same on the wire.
 */
emoji: string | null,
/**
 * The **whole** summary, not a delta — `CallParticipants`' own
 * reasoning verbatim: the socket replays nothing, so a client that
 * missed one event must not be left counting.
 */
reactions: Array<ReactionGroup>, } | { "t": "typing", channel_id: number, user_id: number, } | { "t": "read", channel_id: number, user_id: number, last_read_seq: number, } | { "t": "channel_created", channel_id: number,
/**
 * For a DM this is the *recipient's* peer, so the row appears named
 * after the right person on each of the two sockets it reaches — which
 * is why acceptance sends this event per viewer and never broadcasts
 * it (D169).
 */
name: string,
/**
 * As on [`ChannelState`] (D168), and omitted for the ordinary kind.
 */
kind?: string, peer_id?: number | null,
/**
 * As on [`ChannelState`] (D73): the row the sidebar inserts on this
 * event has to draw its circle straight away, and the next `state`
 * round trip is a user action away.
 */
created_at: number,
/**
 * Who made it — and therefore the one person already in it, running
 * it (D72). The row a client inserts on this event is otherwise a
 * channel with nobody in it, which is wrong for everybody and wrong
 * in a way the creator can see: their own client offered them a
 * "Join" button for a channel they were already in.
 */
created_by: number, } | { "t": "channel_deleted", channel_id: number, } | { "t": "channel_renamed", channel_id: number,
/**
 * Carried because handing the channel over (D112) broadcasts this same
 * event: a client that only re-read the name would go on drawing the
 * old owner's settings row until the next `GET /v1/state`.
 */
owner_id: number, name: string,
/**
 * As on [`ChannelState`] (D168). A DM's rename event is the one a
 * *display name* change fans out — per viewer, one frame each, so an
 * old client never holds a stale peer name until its next resync.
 */
kind?: string, peer_id?: number | null, description: string | null, avatar_file_id: string | null,
/**
 * The door, as on [`ChannelState`] — public to everybody who may see
 * the channel at all. The settings event carries the same fact to the
 * members; this is how the lock reaches the rest of the stand, which
 * is the audience that has to know what a channel's door is like
 * *before* trying to open it.
 */
is_private: boolean, } | { "t": "channel_settings", channel_id: number, settings: ChannelSettings, } | { "t": "membership", channel_id: number, user_id: number, change: MembershipChange,
/**
 * Whether they administer the channel now. Always false once they are
 * gone.
 */
admin: boolean, } | { "t": "profile_updated", user_id: number, username: string, display_name: string | null,
/**
 * `default` for a gateway that predates the screen: absent reads as
 * "no bio", which is what such a gateway would have meant anyway.
 */
bio: string | null, avatar_file_id: string | null,
/**
 * Registration date, unchanged by definition (D73) — it is here
 * because the event is a whole directory entry, not a delta.
 */
created_at: number,
/**
 * The personal bubble pair (D137), whole-entry like everything else
 * here: `null` means "no colour", and a client that rebuilds the row
 * from the event must not be left guessing whether the pair moved.
 */
bubble_light: string | null, bubble_dark: string | null, } | { "t": "call_started" } & Call | { "t": "call_participants" } & Call | { "t": "call_ended", channel_id: number, reason: CallEndReason, } | { "t": "call_declined", channel_id: number,
/**
 * The decliner.
 */
user_id: number, } | { "t": "friends" } & FriendsSnapshot | { "t": "presence", user_id: number, status: PublicStatus, } | { "t": "presence_sync", presence: Array<PresenceEntry>, } | { "t": "my_presence", status: UserStatus, manual: ManualStatus | null, } | { "t": "error", message: string, };

export type ClientEvent = { "t": "auth", jwt: string, } | { "t": "typing", channel_id: number, } | { "t": "activity", idle: boolean, } | { "t": "pong" };

export type SendBody = { nonce: string, text: string, entities: Array<Entity>, attachments: Array<AttachmentInput>, reply_to_seq?: number | null,
/**
 * [`Message::no_link_preview`] (D289). A gateway older than it ignores
 * the field, and the message gets its card.
 */
no_link_preview?: boolean,
/**
 * How long the message is to live, in seconds from the moment the
 * gateway stores it (disappearing-messages.md D296):
 * [`crate::account::MIN_MESSAGE_TTL_S`]`..=`[`crate::account::MAX_MESSAGE_TTL_S`],
 * and anything else is a 400 rather than a clamp. Absent — the message
 * stays. A gateway older than the field ignores it and the message stays
 * too, which its answer says by carrying no `expires_at_ms`: the one way
 * a sender's client can tell, and it must.
 */
ttl_s?: number | null, };

export type EditBody = { text: string, entities: Array<Entity>,
/**
 * [`Message::no_link_preview`] as the edited message is to have it
 * (D289): an edit replaces the words whole, and whether their link gets
 * a card is said again with them. Absent leaves it as it was — an edit
 * from a client older than the field, made to a message sent from a
 * newer one, must not bring back a card its author closed.
 */
no_link_preview?: boolean | null, };

/** Every `t` this build understands; an unknown one is logged and skipped (§3.1). */
export const SERVER_EVENT_TAGS = ["ready", "message", "message_edited", "message_deleted", "message_expiring", "reaction", "typing", "read", "channel_created", "channel_deleted", "channel_renamed", "channel_settings", "membership", "profile_updated", "call_started", "call_participants", "call_ended", "call_declined", "friends", "presence", "presence_sync", "my_presence", "error"] as const;

/** Every `service.kind` this build can word; an unknown one renders as a visible notice. */
export const SERVICE_KINDS = ["call", "joined", "left", "removed", "admin_granted", "admin_revoked", "renamed", "banned", "unbanned", "voice_muted", "voice_unmuted", "owner_changed"] as const;

/** Every entity `type` this build can draw; an unknown one styles nothing and is dropped on the way out. */
export const ENTITY_TYPES = ["bold", "italic", "underline", "strike", "spoiler", "code", "pre", "blockquote", "text_link", "url", "mention"] as const;

